module.exports = __webpack_public_path__ + "img/cda-head.f355c9a1.svg";